
export const validateNewSpecialConditionsProcess = ({
  t,
  justification,
  objective,
  resultFuture,
  competition,
  comments,
  endUserContactName,
  endUserContactPosition,
  startDate,
  effectiveMonths,
  specialConditionType,
  compensationTable,
  bonusTable,
  combineClicksList,
  bonusLSDiscountSend,
  lowCoverage,
  percentage,
  minimumImp,
  minumimDiscount,
  MinimumPrint,
  category
}) => {
  let missing = [];

  if (category === 1) {
    if (objective === "") missing.push(t('objective'));
    if (justification === "") missing.push(t('Business Justification'));
    if (resultFuture === "") missing.push(t('expectedResult'));
    if (competition === "") missing.push(t('Competition'));
  }
 
  if (comments === "") missing.push(t('comments'));
  if (endUserContactName === "") missing.push(t('contactName'));
  if (endUserContactPosition === "") missing.push(t('jobPosition'));
  if (startDate === "" || startDate === null) missing.push(t('startMonth'));
  if (effectiveMonths === 0 || effectiveMonths === "" || effectiveMonths === null) missing.push(t('effMonth'));
  if (specialConditionType === "" || specialConditionType === null || specialConditionType === undefined) {
    missing.push(t('Special Condition Type'));
  }

  if ( (specialConditionType === 1 || specialConditionType === 22 || specialConditionType === 23 || specialConditionType === 26) && compensationTable.length === 0 ) {
    missing.push(t('committed_price_table'));
  }

  if (specialConditionType === 2 && bonusTable.length === 0) {
    missing.push(t('special_bonus_table'));
  }

  if ((specialConditionType === 7 || specialConditionType === 8 || specialConditionType === 17) && combineClicksList.length === 0) {
    missing.push(t('addCombineClicks'));
  }

  if ((specialConditionType === 22 || (specialConditionType === 23 && lowCoverage)) && bonusLSDiscountSend.length === 0) {
    missing.push(t('missingbonusTable'));
  }

  if ((specialConditionType === 21 || specialConditionType === 23 || specialConditionType === 25 || specialConditionType === 26) && (percentage === "" || percentage === 0 || percentage === undefined || percentage === null)) {
    missing.push(t('addPercentage'));
  }

  if ((specialConditionType === 21 || specialConditionType === 23 || specialConditionType === 25 || specialConditionType === 26) && (minimumImp === 0 || minimumImp === "" || minimumImp === null || minimumImp === undefined)) {
    missing.push(t('addMinimun'));
  }

  if (specialConditionType === 11 && (minumimDiscount === "" || minumimDiscount === 0 || minumimDiscount === null)) {
    missing.push(t('addPercentage'));
  }

  if (specialConditionType === 21 && (MinimumPrint === 0 || MinimumPrint === "" || MinimumPrint === null)) {
    missing.push(t('Minimum Print'));
  }

  if ((specialConditionType === 1 || specialConditionType === 23) && compensationTable.length !== 0) {
    if (compensationTable[compensationTable.length - 1].maxPrint !== 999999999) {
      missing.push(t('missingLastTierTable') + '"' + t('lastTier') + '"');
    }
  }

  if (specialConditionType === 2 && bonusTable.length !== 0) {
    if (bonusTable[bonusTable.length - 1].maxPrint !== 999999999) {
      missing.push(t('missingLastTierTable') + '"' + t('lastTier') + '"');
    }
  }

  if (specialConditionType === 22 || (specialConditionType === 23 && lowCoverage)) {
    if (compensationTable.length !== 0) {
      if (compensationTable[compensationTable.length - 1].maxPrint !== 999999999) {
        missing.push(t('missingLastTierTable') + '"' + t('lastTier') + '"');
      }
    }

    if (bonusLSDiscountSend.length !== 0) {
      if (bonusLSDiscountSend[bonusLSDiscountSend.length - 1].FinalLSMark !== 9999) {
        missing.push(t('missingLastTierTable') + '"' + t('lastTier') + '"');
      }
    }
  }

  if (missing.length > 0) {
    let missingFields = "";
    for (let i = 0; i < missing.length; i++) {
      missingFields += "-" + missing[i] + "\n";
    }

    return {
      isValid: false,
      message: t('missingMandatoryFields') + "\n" + missingFields,
    };
  }

  return {
    isValid: true,
    message: "",
  };
};
